<template>
  <div class="initiation-details">
    <v-snackbar v-model="showMessage" :color="taskStatus">
      {{ message }}
      <v-btn icon color="white" text @click="showMessage = false">
        <v-icon size="28">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-combobox
      label="Work Order #"
      :items="workOrdersSelect"
      v-model="workOrderSelected"
      :search-input.sync="searchWorkOrder"
      chips
      hide-no-data
      clearable
      item-text="text"
      item-value="value"
      :disabled="isDisabled"
    ></v-combobox>
    <v-select v-if="newOrder" v-model="typeId" :items="types" label="Work Order Type"></v-select>    

    <v-text-field :disabled="isDisabled" label="Task #" v-model="task.taskNumber"  @keyup="timeOut"></v-text-field>

    <v-text-field :disabled="isDisabled" label="ESO #" v-model="task.eso" @keyup="timeOut"></v-text-field>

    <v-select :disabled="isDisabled" v-model="task.regionId" :items="regions" label="Select Region"></v-select>

    <v-text-field v-model="task.address" :disabled="true"></v-text-field>
    <v-row>
       <v-col cols="12" sm="6">
    <div :class="isDisabledStyle">
      <div class="v-input__control">
        <div class="v-input__slot">
          <vue-google-autocomplete
            id="map"
            class
            ref="address"
            placeholder="Search google for an address"
            :country="['can']"
            v-on:placechanged="getAddressData"
            :disabled="isDisabled"
          ></vue-google-autocomplete>
        </div>
      </div>
    </div>
    </v-col>
    <v-col cols="12" sm="6">
   <div :class="isDisabled">
     <v-text-field  label="Manually enter an address" v-model="addressManual"  @keyup="timeOutAddress" ></v-text-field>
    </div>
    </v-col>
    </v-row>
    <v-row>
    <v-col cols="12" sm="6">
       <v-text-field :disabled="isDisabled" label="Latitude" v-model="task.latitude"  @keyup="timeOut"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
       <v-text-field :disabled="isDisabled" label="Longitude" v-model="task.longitude" @keyup="timeOut"></v-text-field>
      </v-col>
    </v-row>
    <v-menu
      v-model="calendar"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="isDisabled"
    >
      <v-date-picker v-model="task.isd" @input="calendar = false"></v-date-picker>
      <template v-slot:activator="{ on }">
        <v-text-field :disabled="isDisabled" v-model="task.isd" label="ISD" readonly v-on="on"></v-text-field>
      </template>
    </v-menu>
    <v-textarea :disabled="isDisabled"  label="Description" v-model="task.description"></v-textarea>
  </div>
</template>
<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import planningChecklist from '@/utils/planningChecklistObject'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'InitiationDetails',
  components: {
    VueGoogleAutocomplete
    },
    props: {
      isSaved: {
        type: Function,
        required: true
      }
    },
  mounted () {
    this.loadWorkOrders()
    this.loadRegions()
    if (this.task) {
      this.isSaved(true)
    }
  },
  watch: {
    searchWorkOrder(val) {
      this.loadWorkOrders(val)
    },
    'task.isd'(newValue, oldValue) {
      if (this.selectedTask) {
        if (oldValue !== null && oldValue !== new Date().toISOString().substr(0, 10) ) {
          this.isSaved(false) 
        }
      } else {
        this.isSaved(false) 
      }
    },
    'task.workOrderId'(newValue,oldValue) {
      if (this.selectedTask) {
        if (oldValue !== null) {
          this.isSaved(false) 
        }
      } else {
        this.isSaved(false) 
      }
    },
    'task.regionId'(newValue,oldValue) {
      if (this.selectedTask) {
        if (oldValue !== null) {
          this.isSaved(false) 
        }
      } else {
        this.isSaved(false) 
      }
    }
  },
  created () {
    this.loadRegions()
    if (this.selectedTask !== null) {
      this.editing = true
      this.task = this.selectedTask
      this.workOrderSelected = { text: this.selectedTask.workOrder.workOrderNumber, value: this.selectedTask.workOrderId }
      this.task.isd = new Date(this.task.isd).toISOString().substr(0, 10)
      this.isSaved(true) 
    } else {
      this.isSaved(false) 
    }
  },
  data () {
    return {
      editing: false,
      task: {
        workOrderId: null,
        taskNumber: null,
        description: null,
        eso: null,
        address: null,
        isd: new Date().toISOString().substr(0, 10),
        latitude: null,
        longitude: null,
        regionId: null,
      },
      workOrderSelected: null,
      typeId: null,
      types: [{ text: 'ROC', value: 1 }],
      showMessage: false,
      message: '',
      calendar: false,
      taskCreationResponse: {},
      childFileData: null,
      taskId: null,
      taskStatus: 'info',      
      taskAddress: null,
      searchWorkOrder: null,
      addressManual: null,
      addressGoogle: null,
      addressHint: true,
    }
  },
  methods: {
    ...mapActions({
      createNewTask: 'workOrderTask/createTask',
      updateTask: 'workOrderTask/updateTask',
      createWorkOrder: 'workOrder/createWorkOrder',
      updateWorkOrder: 'workOrder/updateWorkOrder',
      loadChecklist: 'checklist/loadChecklistByTask',
      loadWorkOrders: 'workOrder/loadWorkOrderNumbers',
      loadRegions: 'region/loadRegions',
      loadTaskDocuments: 'document/loadDocsByTask',
      loadTaskImages: 'image/loadImagesByTask',
      createChecklist: 'checklist/addChecklist'
    }),
    async clickSave() { //TODO: This needs to be refactored to be more readable
     
      if (this.task.workOrderId === null && !this.workOrderSelected) {
        this.display('Not Valid. A work order # is required')
        return
      } else if (this.task.regionId === null) {
        this.display('Not Valid. A region is required')
        return
      } else if (this.task.taskNumber === null) {
        this.display('Not Valid. A task # is required')
        return
      }
      // Create with new work order
      if (typeof this.workOrderSelected === 'string') {
        if (this.task.workOrderId === null) {
          let res = await this.createWorkOrder({
            workOrderNumber: this.workOrderSelected,
            typeId: this.typeId
          })
          this.task.workOrderId = res.data.id
        } else {
          await this.updateWorkOrder({
            id: this.task.workOrderId,
            workOrderNumber: this.workOrderSelected,
            typeId: this.typeId
          })
        }
      }
      if (typeof this.workOrderSelected === 'object') {
        this.task.workOrderId = this.workOrderSelected.value
      }
      if (this.taskId == null) {
        if (this.editing) {
          typeof this.task.workOrder === 'object' && delete this.task.workOrder
          typeof this.task.region === 'object' &&  delete this.task.region
          this.taskCreationResponse = await this.updateTask(this.task)
          if (this.taskCreationResponse === 'Request failed with status code 400') {
            this.display('Task Number Already Exists')
            return
          }
          this.isSaved(true)
          this.loadTaskDocuments(this.task.id)
          this.loadTaskImages({ taskId: this.task.id, size: 'small' })
          planningChecklist.workOrderTaskId = this.task.id
        } else {
          this.taskCreationResponse = await this.createNewTask(this.task)
          if (this.taskCreationResponse === 'Request failed with status code 400') {
            this.display('Task Number Already Exists')
            return
          } else if (this.taskCreationResponse.data !== undefined) {
            planningChecklist.workOrderTaskId = this.taskCreationResponse.data.id
            await this.createChecklist(planningChecklist)
            // setting task id
            this.task.id = this.selectedTask.id
          }
          this.isSaved(true)
        }

        this.display('Task ' + this.taskCreationResponse.statusText)
        this.$emit('task', this.taskCreationResponse)
        if (this.taskCreationResponse.status === 201) {
          this.taskId = this.taskCreationResponse.data.id
          this.e1 = 2
          this.loadChecklist(this.task.id)
        }
      } else {
        let res = await this.updateTask(this.task)
        this.isSaved(true)
        this.display('Task ' + res.statusText)
      }

      this.$refs.address.update(null)
      this.addressGoogle = null
      this.addressManual = null
    },
    clear () {
      this.taskCreationResponse = {}
      this.taskId = null
      this.task.address = null
      this.task.eSO = null
      this.task.description = null
      this.workOrderSelected = null
      this.task.taskNumber = null
      this.task.regionId = null
      this.task.latitude = null
      this.task.longitude = null
    },
    display (message) {
      this.message = message
      if (this.message === 'Task Created' || this.message === 'Task OK') {
        this.taskStatus = 'success'
      } else {
        this.taskStatus = 'error'
      }
      this.showMessage = true
    },
    getAddressData (data) {
      const field = document.querySelector('input[id=map]').value
      this.task.latitude = data.latitude
      this.task.longitude = data.longitude
      this.addressGoogle = field

      if (field !== null) {        
         this.timeOutAddress() 
      }
    },
   timeOut() {
        if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        }
      this.timer = setTimeout(() => {
         this.isSaved(false) 
        }, 800);
    },
    timeOutAddress () {
        if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        }
      this.timer = setTimeout(() => {
        this.task.address =  this.addressGoogle !== null ?  this.addressGoogle: this.addressManual 
         this.isSaved(false) 
        }, 800);
    }
  },
  computed: {
    ...mapGetters({
      workOrders: 'workOrder/workOrders',
      tasks: 'workOrderTask/tasks',
      headers: 'workOrder/headers',
      error: 'workOrderTask/error',
      workOrdersSelect: 'workOrder/workOrdersSelect',
      regions: 'region/selectList',
      selectedTask: 'workOrderTask/selectedTask',
      userRole: 'user/role'
    }),
    newOrder () {
      return typeof this.workOrderSelected === 'string'
    },
    isDisabled () {
      if (this.userRole === 'Sub Foreman') {
        return true
      } else {
        return false
      }
    },
    isDisabledStyle () {
      if (this.userRole === 'Sub Foreman') {
        return 'v-input--is-disabled theme--light v-text-field v-text-field--is-booted'
      } else {
        return 'v-input theme--light v-text-field v-text-field--is-booted'
      }
    }
  }
}
</script>
<style scoped>
::placeholder {
  color: rgba(0, 0, 0, 0.6) !important;
}


</style>
